import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "../Sidebar/Sidebar"; // adjust path if needed
import "./PharmacyBranches.css";

const PharmacyBranches = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Search term state

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await axios.get(
          "http://127.0.0.1:8000/users/pharmacies/branches",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
        setBranches(response.data);
      } catch (err) {
        setError("Failed to load branches");
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  // ✅ Filter branches by search term
  const filteredBranches = branches.filter(
    (branch) =>
      branch.branch_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      branch.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      branch.branch_address?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <p className="loading-text">Loading pharmacy branches...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <div className="pharmacy-page-container">
      <Sidebar />

      <div className="pharmacy-content">
        <h2 className="pharmacy-title">Pharmacy Branches</h2>

        {/* ✅ Search Field */}
        <input
          type="text"
          placeholder="🔍 Search branches..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />

        {filteredBranches.length === 0 ? (
          <p className="no-branches-text">No matching branches found.</p>
        ) : (
          <div className="pharmacy-cards">
            {filteredBranches.map((branch, index) => (
              <div key={branch.id} className="pharmacy-card">
                <h3 className="branch-number">Branch {index + 1}</h3>
                <p>
                  <strong>Branch Name:</strong> {branch.branch_name}
                </p>
                <p>
                  <strong>User Name:</strong> {branch.user_name}
                </p>
                <p>
                  <strong>Address:</strong> {branch.branch_address}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PharmacyBranches;
